import Switch from '@material-ui/core/Switch';
import { SwitchProps } from '@material-ui/core/Switch/Switch';
import { styled } from '@mui/material';
import React from 'react';
import { Color } from 'utils/color';

export const Switcher = styled((props: SwitchProps) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
  width: '42px !important',
  height: '26px !important',
  padding: '0 !important',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: Color.WHITE,
      '& + .MuiSwitch-track': {
        backgroundColor: Color.GRAY_BLUE,
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: Color.DARK_BLUE_700
        })
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: Color.GRAY_BLUE,
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600]
      })
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3
      })
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: Color.GRAY_100,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: Color.GRAY_950
    })
  }
}));
